import getPaginationString from "../helpers/getPaginationString";
import action from "../helpers/rest-client";
import { GetSubscribersOutDto } from "../types/community";
import { PaginationOutDto } from "../types/pagination";

export class ErrorCommunity extends Error { }

const convertFiltersToQueryString = (filters?: any) => {
  // Convertir arrays a strings separados por comas
  const filtersForQuery: Record<string, string> = {};
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        filtersForQuery[key] = value.join(',');
      } else {
        filtersForQuery[key] = String(value);
      }
    });
  }

  return new URLSearchParams(filtersForQuery).toString();
};

class Community {
  public async getSubscribers(payload: GetSubscribersOutDto) {
    const pagination = !payload?.pagination ? 'paginate=false' : getPaginationString(payload?.pagination);
    const queryString = convertFiltersToQueryString(payload?.filters);

    console.log(`/api/community/${payload?.group_id}/subscribers?${pagination}${queryString ? `&${queryString}` : ''}`);

    return action
      .Get({
        url: `/api/community/${payload?.group_id}/subscribers?${pagination}${queryString ? `&${queryString}` : ''}`,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }

  public async exportSubscribers(payload: GetSubscribersOutDto) {
    const queryString = convertFiltersToQueryString(payload?.filters);

    console.log(`/api/community/export/subscribers?paginate=false${queryString ? `&${queryString}` : ''}`);

    action
      .Get({
        url: `/api/community/export/subscribers?${queryString ? queryString : ''}`,
      })
      .then((response) => {
        const binary = new Uint8Array(response.data);

        const buftype =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8";

        const url = window.URL.createObjectURL(
          new Blob([binary], {
            type: buftype,
          })
        );

        // Create blob link to download
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Suscriptores" + ".xlsx");

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link?.parentNode?.removeChild(link);
      })
      .catch((error) => {
        return error;
      });
  }

  public async getCommunityMetrics() {
    return action
      .Get({
        url: `/api/community/metrics`,
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw new ErrorCommunity("Error al obtener metricas de la comunidad.");
      });
  }

  public async subscribe(data) {
    return action
      .Post({
        url: `/api/community/new-subscriber`,
        body: data,
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }
}

const community = new Community();
export default community;
